var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1208,
    height: 200,
    viewBox: "0 0 1208 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_99362)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_654_99362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.1064 30.0127V23.0469H94.8154V30.0127C94.8154 30.6735 94.6742 31.2363 94.3916 31.7012C94.109 32.166 93.724 32.5215 93.2363 32.7676C92.7487 33.0137 92.195 33.1367 91.5752 33.1367C90.9417 33.1367 90.3789 33.0296 89.8867 32.8154C89.3991 32.6012 89.0163 32.2731 88.7383 31.8311C88.4603 31.389 88.3213 30.8285 88.3213 30.1494H90.0439C90.0439 30.5413 90.1055 30.8581 90.2285 31.0996C90.3561 31.3366 90.5339 31.5098 90.7617 31.6191C90.9941 31.724 91.2653 31.7764 91.5752 31.7764C91.8714 31.7764 92.1335 31.7103 92.3613 31.5781C92.5938 31.4414 92.776 31.2432 92.9082 30.9834C93.0404 30.7191 93.1064 30.3955 93.1064 30.0127ZM100.967 31.5166V27.9893C100.967 27.7249 100.919 27.4971 100.823 27.3057C100.728 27.1143 100.582 26.9661 100.386 26.8613C100.194 26.7565 99.9529 26.7041 99.6612 26.7041C99.3923 26.7041 99.1599 26.7497 98.9639 26.8408C98.768 26.932 98.6153 27.055 98.5059 27.21C98.3966 27.3649 98.3419 27.5404 98.3419 27.7363H96.7013C96.7013 27.4447 96.7719 27.1621 96.9132 26.8887C97.0544 26.6152 97.2595 26.3714 97.5284 26.1572C97.7973 25.943 98.1186 25.7744 98.4923 25.6514C98.866 25.5283 99.2852 25.4668 99.7501 25.4668C100.306 25.4668 100.798 25.5602 101.227 25.7471C101.66 25.9339 101.999 26.2165 102.245 26.5947C102.496 26.9684 102.621 27.4378 102.621 28.0029V31.291C102.621 31.6283 102.644 31.9313 102.69 32.2002C102.74 32.4645 102.81 32.6947 102.901 32.8906V33H101.213C101.135 32.8223 101.074 32.5967 101.028 32.3232C100.987 32.0452 100.967 31.7764 100.967 31.5166ZM101.206 28.502L101.22 29.5205H100.037C99.7318 29.5205 99.463 29.5501 99.2305 29.6094C98.9981 29.6641 98.8044 29.7461 98.6495 29.8555C98.4945 29.9648 98.3783 30.097 98.3009 30.252C98.2234 30.4069 98.1846 30.5824 98.1846 30.7783C98.1846 30.9743 98.2302 31.1543 98.3214 31.3184C98.4125 31.4779 98.5447 31.6032 98.7179 31.6943C98.8956 31.7855 99.1098 31.8311 99.3604 31.8311C99.6977 31.8311 99.9916 31.7627 100.242 31.626C100.497 31.4847 100.698 31.3138 100.844 31.1133C100.99 30.9082 101.067 30.7145 101.076 30.5322L101.609 31.2637C101.555 31.4505 101.461 31.651 101.329 31.8652C101.197 32.0794 101.024 32.2845 100.81 32.4805C100.6 32.6719 100.347 32.8291 100.051 32.9521C99.7592 33.0752 99.422 33.1367 99.0391 33.1367C98.5561 33.1367 98.1254 33.041 97.7471 32.8496C97.3689 32.6536 97.0727 32.3916 96.8585 32.0635C96.6443 31.7308 96.5372 31.3548 96.5372 30.9355C96.5372 30.5436 96.6101 30.1973 96.7559 29.8965C96.9063 29.5911 97.1251 29.3359 97.4122 29.1309C97.7039 28.9258 98.0593 28.7708 98.4786 28.666C98.8979 28.5566 99.3764 28.502 99.9141 28.502H101.206ZM106.148 27.1826V33H104.5V25.6035H106.052L106.148 27.1826ZM105.854 29.0283L105.32 29.0215C105.325 28.4974 105.398 28.0166 105.539 27.5791C105.685 27.1416 105.886 26.7656 106.141 26.4512C106.401 26.1367 106.71 25.8952 107.07 25.7266C107.43 25.5534 107.832 25.4668 108.274 25.4668C108.629 25.4668 108.95 25.5169 109.237 25.6172C109.529 25.7129 109.778 25.8701 109.983 26.0889C110.192 26.3076 110.352 26.5924 110.461 26.9434C110.57 27.2897 110.625 27.7158 110.625 28.2217V33H108.971V28.2148C108.971 27.8594 108.918 27.5791 108.814 27.374C108.713 27.1644 108.565 27.0163 108.369 26.9297C108.178 26.8385 107.939 26.793 107.652 26.793C107.369 26.793 107.116 26.8522 106.893 26.9707C106.669 27.0892 106.48 27.251 106.325 27.4561C106.175 27.6611 106.059 27.8981 105.977 28.167C105.895 28.4359 105.854 28.723 105.854 29.0283Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8477 47.4688H24.9434L27.7383 54.4238L30.5273 47.4688H31.6289L28.1602 56H27.3047L23.8477 47.4688ZM23.4902 47.4688H24.457L24.6152 52.6719V56H23.4902V47.4688ZM31.0137 47.4688H31.9805V56H30.8555V52.6719L31.0137 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1426 47.4688V56H51.0293V47.4688H52.1426ZM54.8848 47.4688V48.3945H48.293V47.4688H54.8848Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7344 53.4219L75.4277 47.4688H76.248L75.7734 49.7832L73.9512 56H73.1367L73.7344 53.4219ZM71.9824 47.4688L73.3301 53.3047L73.7344 56H72.9258L70.8574 47.4688H71.9824ZM78.4395 53.2988L79.7578 47.4688H80.8887L78.8262 56H78.0176L78.4395 53.2988ZM76.3711 47.4688L78.0176 53.4219L78.6152 56H77.8008L76.043 49.7832L75.5625 47.4688H76.3711Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.143 47.4688V56H99.0293V47.4688H100.143ZM102.885 47.4688V48.3945H96.293V47.4688H102.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.621 47.4688V56H121.49V47.4688H122.621ZM126.195 51.3066V52.2324H122.375V51.3066H126.195ZM126.775 47.4688V48.3945H122.375V47.4688H126.775Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.537 53.8438C149.537 53.6445 149.506 53.4688 149.443 53.3164C149.385 53.1602 149.279 53.0195 149.127 52.8945C148.979 52.7695 148.771 52.6504 148.506 52.5371C148.244 52.4238 147.912 52.3086 147.51 52.1914C147.088 52.0664 146.707 51.9277 146.367 51.7754C146.027 51.6191 145.736 51.4414 145.494 51.2422C145.252 51.043 145.066 50.8145 144.938 50.5566C144.809 50.2988 144.744 50.0039 144.744 49.6719C144.744 49.3398 144.812 49.0332 144.949 48.752C145.086 48.4707 145.281 48.2266 145.535 48.0195C145.793 47.8086 146.1 47.6445 146.455 47.5273C146.811 47.4102 147.207 47.3516 147.645 47.3516C148.285 47.3516 148.828 47.4746 149.273 47.7207C149.723 47.9629 150.064 48.2812 150.299 48.6758C150.533 49.0664 150.65 49.4844 150.65 49.9297H149.525C149.525 49.6094 149.457 49.3262 149.32 49.0801C149.184 48.8301 148.977 48.6348 148.699 48.4941C148.422 48.3496 148.07 48.2773 147.645 48.2773C147.242 48.2773 146.91 48.3379 146.648 48.459C146.387 48.5801 146.191 48.7441 146.062 48.9512C145.938 49.1582 145.875 49.3945 145.875 49.6602C145.875 49.8398 145.912 50.0039 145.986 50.1523C146.064 50.2969 146.184 50.4316 146.344 50.5566C146.508 50.6816 146.715 50.7969 146.965 50.9023C147.219 51.0078 147.521 51.1094 147.873 51.207C148.357 51.3438 148.775 51.4961 149.127 51.6641C149.479 51.832 149.768 52.0215 149.994 52.2324C150.225 52.4395 150.395 52.6758 150.504 52.9414C150.617 53.2031 150.674 53.5 150.674 53.832C150.674 54.1797 150.604 54.4941 150.463 54.7754C150.322 55.0566 150.121 55.2969 149.859 55.4961C149.598 55.6953 149.283 55.8496 148.916 55.959C148.553 56.0645 148.146 56.1172 147.697 56.1172C147.303 56.1172 146.914 56.0625 146.531 55.9531C146.152 55.8438 145.807 55.6797 145.494 55.4609C145.186 55.2422 144.938 54.9727 144.75 54.6523C144.566 54.3281 144.475 53.9531 144.475 53.5273H145.6C145.6 53.8203 145.656 54.0723 145.77 54.2832C145.883 54.4902 146.037 54.6621 146.232 54.7988C146.432 54.9355 146.656 55.0371 146.906 55.1035C147.16 55.166 147.424 55.1973 147.697 55.1973C148.092 55.1973 148.426 55.1426 148.699 55.0332C148.973 54.9238 149.18 54.7676 149.32 54.5645C149.465 54.3613 149.537 54.1211 149.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.537 53.8438C173.537 53.6445 173.506 53.4688 173.443 53.3164C173.385 53.1602 173.279 53.0195 173.127 52.8945C172.979 52.7695 172.771 52.6504 172.506 52.5371C172.244 52.4238 171.912 52.3086 171.51 52.1914C171.088 52.0664 170.707 51.9277 170.367 51.7754C170.027 51.6191 169.736 51.4414 169.494 51.2422C169.252 51.043 169.066 50.8145 168.938 50.5566C168.809 50.2988 168.744 50.0039 168.744 49.6719C168.744 49.3398 168.812 49.0332 168.949 48.752C169.086 48.4707 169.281 48.2266 169.535 48.0195C169.793 47.8086 170.1 47.6445 170.455 47.5273C170.811 47.4102 171.207 47.3516 171.645 47.3516C172.285 47.3516 172.828 47.4746 173.273 47.7207C173.723 47.9629 174.064 48.2812 174.299 48.6758C174.533 49.0664 174.65 49.4844 174.65 49.9297H173.525C173.525 49.6094 173.457 49.3262 173.32 49.0801C173.184 48.8301 172.977 48.6348 172.699 48.4941C172.422 48.3496 172.07 48.2773 171.645 48.2773C171.242 48.2773 170.91 48.3379 170.648 48.459C170.387 48.5801 170.191 48.7441 170.062 48.9512C169.938 49.1582 169.875 49.3945 169.875 49.6602C169.875 49.8398 169.912 50.0039 169.986 50.1523C170.064 50.2969 170.184 50.4316 170.344 50.5566C170.508 50.6816 170.715 50.7969 170.965 50.9023C171.219 51.0078 171.521 51.1094 171.873 51.207C172.357 51.3438 172.775 51.4961 173.127 51.6641C173.479 51.832 173.768 52.0215 173.994 52.2324C174.225 52.4395 174.395 52.6758 174.504 52.9414C174.617 53.2031 174.674 53.5 174.674 53.832C174.674 54.1797 174.604 54.4941 174.463 54.7754C174.322 55.0566 174.121 55.2969 173.859 55.4961C173.598 55.6953 173.283 55.8496 172.916 55.959C172.553 56.0645 172.146 56.1172 171.697 56.1172C171.303 56.1172 170.914 56.0625 170.531 55.9531C170.152 55.8438 169.807 55.6797 169.494 55.4609C169.186 55.2422 168.938 54.9727 168.75 54.6523C168.566 54.3281 168.475 53.9531 168.475 53.5273H169.6C169.6 53.8203 169.656 54.0723 169.77 54.2832C169.883 54.4902 170.037 54.6621 170.232 54.7988C170.432 54.9355 170.656 55.0371 170.906 55.1035C171.16 55.166 171.424 55.1973 171.697 55.1973C172.092 55.1973 172.426 55.1426 172.699 55.0332C172.973 54.9238 173.18 54.7676 173.32 54.5645C173.465 54.3613 173.537 54.1211 173.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.728 23.0469V33H273.012V23.0469H274.728ZM278.788 27.4014V28.7617H274.29V27.4014H278.788ZM279.355 23.0469V24.4141H274.29V23.0469H279.355ZM283.839 33.1367C283.292 33.1367 282.798 33.0479 282.356 32.8701C281.918 32.6878 281.544 32.4349 281.234 32.1113C280.929 31.7878 280.694 31.4072 280.53 30.9697C280.366 30.5322 280.284 30.0605 280.284 29.5547V29.2812C280.284 28.7025 280.369 28.1784 280.537 27.709C280.706 27.2396 280.941 26.8385 281.241 26.5059C281.542 26.1686 281.898 25.9111 282.308 25.7334C282.718 25.5557 283.162 25.4668 283.641 25.4668C284.169 25.4668 284.632 25.5557 285.028 25.7334C285.425 25.9111 285.753 26.1618 286.013 26.4854C286.277 26.8044 286.473 27.1849 286.601 27.627C286.733 28.069 286.799 28.5566 286.799 29.0898V29.7939H281.084V28.6113H285.172V28.4814C285.163 28.1852 285.104 27.9072 284.994 27.6475C284.889 27.3877 284.728 27.1781 284.509 27.0186C284.29 26.859 283.998 26.7793 283.634 26.7793C283.36 26.7793 283.117 26.8385 282.902 26.957C282.693 27.071 282.517 27.2373 282.376 27.4561C282.235 27.6748 282.125 27.9391 282.048 28.249C281.975 28.5544 281.939 28.8984 281.939 29.2812V29.5547C281.939 29.8783 281.982 30.179 282.068 30.457C282.16 30.7305 282.292 30.9697 282.465 31.1748C282.638 31.3799 282.848 31.5417 283.094 31.6602C283.34 31.7741 283.62 31.8311 283.935 31.8311C284.331 31.8311 284.684 31.7513 284.994 31.5918C285.304 31.4323 285.573 31.2067 285.801 30.915L286.669 31.7559C286.51 31.9883 286.302 32.2116 286.047 32.4258C285.792 32.6354 285.48 32.8063 285.11 32.9385C284.746 33.0706 284.322 33.1367 283.839 33.1367ZM288.261 22.5H289.908V31.4209L289.751 33H288.261V22.5ZM294.735 29.2334V29.377C294.735 29.9238 294.673 30.4274 294.55 30.8877C294.431 31.3434 294.249 31.7399 294.003 32.0771C293.762 32.4144 293.461 32.6764 293.101 32.8633C292.745 33.0456 292.333 33.1367 291.863 33.1367C291.403 33.1367 291.002 33.0501 290.66 32.877C290.319 32.7038 290.031 32.4577 289.799 32.1387C289.571 31.8197 289.387 31.4391 289.245 30.9971C289.104 30.555 289.004 30.0674 288.944 29.5342V29.0762C289.004 28.5384 289.104 28.0508 289.245 27.6133C289.387 27.1712 289.571 26.7907 289.799 26.4717C290.031 26.1481 290.316 25.8997 290.653 25.7266C290.995 25.5534 291.394 25.4668 291.85 25.4668C292.324 25.4668 292.741 25.5579 293.101 25.7402C293.465 25.9225 293.768 26.1823 294.01 26.5195C294.251 26.8522 294.431 27.2487 294.55 27.709C294.673 28.1693 294.735 28.6774 294.735 29.2334ZM293.087 29.377V29.2334C293.087 28.9007 293.06 28.5885 293.005 28.2969C292.95 28.0007 292.859 27.7409 292.732 27.5176C292.609 27.2943 292.44 27.1188 292.226 26.9912C292.016 26.859 291.754 26.793 291.44 26.793C291.148 26.793 290.897 26.8431 290.688 26.9434C290.478 27.0436 290.303 27.1803 290.161 27.3535C290.02 27.5267 289.908 27.7272 289.826 27.9551C289.749 28.1829 289.696 28.429 289.669 28.6934V29.9307C289.71 30.2725 289.797 30.5869 289.929 30.874C290.066 31.1566 290.257 31.3844 290.503 31.5576C290.749 31.7262 291.066 31.8105 291.453 31.8105C291.759 31.8105 292.016 31.749 292.226 31.626C292.435 31.5029 292.602 31.332 292.725 31.1133C292.852 30.89 292.944 30.6302 292.998 30.334C293.057 30.0378 293.087 29.7188 293.087 29.377Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.848 47.4688H208.943L211.738 54.4238L214.527 47.4688H215.629L212.16 56H211.305L207.848 47.4688ZM207.49 47.4688H208.457L208.615 52.6719V56H207.49V47.4688ZM215.014 47.4688H215.98V56H214.855V52.6719L215.014 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.143 47.4688V56H235.029V47.4688H236.143ZM238.885 47.4688V48.3945H232.293V47.4688H238.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.734 53.4219L259.428 47.4688H260.248L259.773 49.7832L257.951 56H257.137L257.734 53.4219ZM255.982 47.4688L257.33 53.3047L257.734 56H256.926L254.857 47.4688H255.982ZM262.439 53.2988L263.758 47.4688H264.889L262.826 56H262.018L262.439 53.2988ZM260.371 47.4688L262.018 53.4219L262.615 56H261.801L260.043 49.7832L259.562 47.4688H260.371Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.143 47.4688V56H283.029V47.4688H284.143ZM286.885 47.4688V48.3945H280.293V47.4688H286.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.621 47.4688V56H305.49V47.4688H306.621ZM310.195 51.3066V52.2324H306.375V51.3066H310.195ZM310.775 47.4688V48.3945H306.375V47.4688H310.775Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.537 53.8438C333.537 53.6445 333.506 53.4688 333.443 53.3164C333.385 53.1602 333.279 53.0195 333.127 52.8945C332.979 52.7695 332.771 52.6504 332.506 52.5371C332.244 52.4238 331.912 52.3086 331.51 52.1914C331.088 52.0664 330.707 51.9277 330.367 51.7754C330.027 51.6191 329.736 51.4414 329.494 51.2422C329.252 51.043 329.066 50.8145 328.938 50.5566C328.809 50.2988 328.744 50.0039 328.744 49.6719C328.744 49.3398 328.812 49.0332 328.949 48.752C329.086 48.4707 329.281 48.2266 329.535 48.0195C329.793 47.8086 330.1 47.6445 330.455 47.5273C330.811 47.4102 331.207 47.3516 331.645 47.3516C332.285 47.3516 332.828 47.4746 333.273 47.7207C333.723 47.9629 334.064 48.2812 334.299 48.6758C334.533 49.0664 334.65 49.4844 334.65 49.9297H333.525C333.525 49.6094 333.457 49.3262 333.32 49.0801C333.184 48.8301 332.977 48.6348 332.699 48.4941C332.422 48.3496 332.07 48.2773 331.645 48.2773C331.242 48.2773 330.91 48.3379 330.648 48.459C330.387 48.5801 330.191 48.7441 330.062 48.9512C329.938 49.1582 329.875 49.3945 329.875 49.6602C329.875 49.8398 329.912 50.0039 329.986 50.1523C330.064 50.2969 330.184 50.4316 330.344 50.5566C330.508 50.6816 330.715 50.7969 330.965 50.9023C331.219 51.0078 331.521 51.1094 331.873 51.207C332.357 51.3438 332.775 51.4961 333.127 51.6641C333.479 51.832 333.768 52.0215 333.994 52.2324C334.225 52.4395 334.395 52.6758 334.504 52.9414C334.617 53.2031 334.674 53.5 334.674 53.832C334.674 54.1797 334.604 54.4941 334.463 54.7754C334.322 55.0566 334.121 55.2969 333.859 55.4961C333.598 55.6953 333.283 55.8496 332.916 55.959C332.553 56.0645 332.146 56.1172 331.697 56.1172C331.303 56.1172 330.914 56.0625 330.531 55.9531C330.152 55.8438 329.807 55.6797 329.494 55.4609C329.186 55.2422 328.938 54.9727 328.75 54.6523C328.566 54.3281 328.475 53.9531 328.475 53.5273H329.6C329.6 53.8203 329.656 54.0723 329.77 54.2832C329.883 54.4902 330.037 54.6621 330.232 54.7988C330.432 54.9355 330.656 55.0371 330.906 55.1035C331.16 55.166 331.424 55.1973 331.697 55.1973C332.092 55.1973 332.426 55.1426 332.699 55.0332C332.973 54.9238 333.18 54.7676 333.32 54.5645C333.465 54.3613 333.537 54.1211 333.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.537 53.8438C357.537 53.6445 357.506 53.4688 357.443 53.3164C357.385 53.1602 357.279 53.0195 357.127 52.8945C356.979 52.7695 356.771 52.6504 356.506 52.5371C356.244 52.4238 355.912 52.3086 355.51 52.1914C355.088 52.0664 354.707 51.9277 354.367 51.7754C354.027 51.6191 353.736 51.4414 353.494 51.2422C353.252 51.043 353.066 50.8145 352.938 50.5566C352.809 50.2988 352.744 50.0039 352.744 49.6719C352.744 49.3398 352.812 49.0332 352.949 48.752C353.086 48.4707 353.281 48.2266 353.535 48.0195C353.793 47.8086 354.1 47.6445 354.455 47.5273C354.811 47.4102 355.207 47.3516 355.645 47.3516C356.285 47.3516 356.828 47.4746 357.273 47.7207C357.723 47.9629 358.064 48.2812 358.299 48.6758C358.533 49.0664 358.65 49.4844 358.65 49.9297H357.525C357.525 49.6094 357.457 49.3262 357.32 49.0801C357.184 48.8301 356.977 48.6348 356.699 48.4941C356.422 48.3496 356.07 48.2773 355.645 48.2773C355.242 48.2773 354.91 48.3379 354.648 48.459C354.387 48.5801 354.191 48.7441 354.062 48.9512C353.938 49.1582 353.875 49.3945 353.875 49.6602C353.875 49.8398 353.912 50.0039 353.986 50.1523C354.064 50.2969 354.184 50.4316 354.344 50.5566C354.508 50.6816 354.715 50.7969 354.965 50.9023C355.219 51.0078 355.521 51.1094 355.873 51.207C356.357 51.3438 356.775 51.4961 357.127 51.6641C357.479 51.832 357.768 52.0215 357.994 52.2324C358.225 52.4395 358.395 52.6758 358.504 52.9414C358.617 53.2031 358.674 53.5 358.674 53.832C358.674 54.1797 358.604 54.4941 358.463 54.7754C358.322 55.0566 358.121 55.2969 357.859 55.4961C357.598 55.6953 357.283 55.8496 356.916 55.959C356.553 56.0645 356.146 56.1172 355.697 56.1172C355.303 56.1172 354.914 56.0625 354.531 55.9531C354.152 55.8438 353.807 55.6797 353.494 55.4609C353.186 55.2422 352.938 54.9727 352.75 54.6523C352.566 54.3281 352.475 53.9531 352.475 53.5273H353.6C353.6 53.8203 353.656 54.0723 353.77 54.2832C353.883 54.4902 354.037 54.6621 354.232 54.7988C354.432 54.9355 354.656 55.0371 354.906 55.1035C355.16 55.166 355.424 55.1973 355.697 55.1973C356.092 55.1973 356.426 55.1426 356.699 55.0332C356.973 54.9238 357.18 54.7676 357.32 54.5645C357.465 54.3613 357.537 54.1211 357.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.728 23.0469V33H457.012V23.0469H458.728ZM462.788 27.4014V28.7617H458.29V27.4014H462.788ZM463.355 23.0469V24.4141H458.29V23.0469H463.355ZM467.839 33.1367C467.292 33.1367 466.798 33.0479 466.356 32.8701C465.918 32.6878 465.544 32.4349 465.234 32.1113C464.929 31.7878 464.694 31.4072 464.53 30.9697C464.366 30.5322 464.284 30.0605 464.284 29.5547V29.2812C464.284 28.7025 464.369 28.1784 464.537 27.709C464.706 27.2396 464.941 26.8385 465.241 26.5059C465.542 26.1686 465.898 25.9111 466.308 25.7334C466.718 25.5557 467.162 25.4668 467.641 25.4668C468.169 25.4668 468.632 25.5557 469.028 25.7334C469.425 25.9111 469.753 26.1618 470.013 26.4854C470.277 26.8044 470.473 27.1849 470.601 27.627C470.733 28.069 470.799 28.5566 470.799 29.0898V29.7939H465.084V28.6113H469.172V28.4814C469.163 28.1852 469.104 27.9072 468.994 27.6475C468.889 27.3877 468.728 27.1781 468.509 27.0186C468.29 26.859 467.998 26.7793 467.634 26.7793C467.36 26.7793 467.117 26.8385 466.902 26.957C466.693 27.071 466.517 27.2373 466.376 27.4561C466.235 27.6748 466.125 27.9391 466.048 28.249C465.975 28.5544 465.939 28.8984 465.939 29.2812V29.5547C465.939 29.8783 465.982 30.179 466.068 30.457C466.16 30.7305 466.292 30.9697 466.465 31.1748C466.638 31.3799 466.848 31.5417 467.094 31.6602C467.34 31.7741 467.62 31.8311 467.935 31.8311C468.331 31.8311 468.684 31.7513 468.994 31.5918C469.304 31.4323 469.573 31.2067 469.801 30.915L470.669 31.7559C470.51 31.9883 470.302 32.2116 470.047 32.4258C469.792 32.6354 469.48 32.8063 469.11 32.9385C468.746 33.0706 468.322 33.1367 467.839 33.1367ZM472.261 22.5H473.908V31.4209L473.751 33H472.261V22.5ZM478.735 29.2334V29.377C478.735 29.9238 478.673 30.4274 478.55 30.8877C478.431 31.3434 478.249 31.7399 478.003 32.0771C477.762 32.4144 477.461 32.6764 477.101 32.8633C476.745 33.0456 476.333 33.1367 475.863 33.1367C475.403 33.1367 475.002 33.0501 474.66 32.877C474.319 32.7038 474.031 32.4577 473.799 32.1387C473.571 31.8197 473.387 31.4391 473.245 30.9971C473.104 30.555 473.004 30.0674 472.944 29.5342V29.0762C473.004 28.5384 473.104 28.0508 473.245 27.6133C473.387 27.1712 473.571 26.7907 473.799 26.4717C474.031 26.1481 474.316 25.8997 474.653 25.7266C474.995 25.5534 475.394 25.4668 475.85 25.4668C476.324 25.4668 476.741 25.5579 477.101 25.7402C477.465 25.9225 477.768 26.1823 478.01 26.5195C478.251 26.8522 478.431 27.2487 478.55 27.709C478.673 28.1693 478.735 28.6774 478.735 29.2334ZM477.087 29.377V29.2334C477.087 28.9007 477.06 28.5885 477.005 28.2969C476.95 28.0007 476.859 27.7409 476.732 27.5176C476.609 27.2943 476.44 27.1188 476.226 26.9912C476.016 26.859 475.754 26.793 475.44 26.793C475.148 26.793 474.897 26.8431 474.688 26.9434C474.478 27.0436 474.303 27.1803 474.161 27.3535C474.02 27.5267 473.908 27.7272 473.826 27.9551C473.749 28.1829 473.696 28.429 473.669 28.6934V29.9307C473.71 30.2725 473.797 30.5869 473.929 30.874C474.066 31.1566 474.257 31.3844 474.503 31.5576C474.749 31.7262 475.066 31.8105 475.453 31.8105C475.759 31.8105 476.016 31.749 476.226 31.626C476.435 31.5029 476.602 31.332 476.725 31.1133C476.852 30.89 476.944 30.6302 476.998 30.334C477.057 30.0378 477.087 29.7188 477.087 29.377Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.848 47.4688H392.943L395.738 54.4238L398.527 47.4688H399.629L396.16 56H395.305L391.848 47.4688ZM391.49 47.4688H392.457L392.615 52.6719V56H391.49V47.4688ZM399.014 47.4688H399.98V56H398.855V52.6719L399.014 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.143 47.4688V56H419.029V47.4688H420.143ZM422.885 47.4688V48.3945H416.293V47.4688H422.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.734 53.4219L443.428 47.4688H444.248L443.773 49.7832L441.951 56H441.137L441.734 53.4219ZM439.982 47.4688L441.33 53.3047L441.734 56H440.926L438.857 47.4688H439.982ZM446.439 53.2988L447.758 47.4688H448.889L446.826 56H446.018L446.439 53.2988ZM444.371 47.4688L446.018 53.4219L446.615 56H445.801L444.043 49.7832L443.562 47.4688H444.371Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.143 47.4688V56H467.029V47.4688H468.143ZM470.885 47.4688V48.3945H464.293V47.4688H470.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.621 47.4688V56H489.49V47.4688H490.621ZM494.195 51.3066V52.2324H490.375V51.3066H494.195ZM494.775 47.4688V48.3945H490.375V47.4688H494.775Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.537 53.8438C517.537 53.6445 517.506 53.4688 517.443 53.3164C517.385 53.1602 517.279 53.0195 517.127 52.8945C516.979 52.7695 516.771 52.6504 516.506 52.5371C516.244 52.4238 515.912 52.3086 515.51 52.1914C515.088 52.0664 514.707 51.9277 514.367 51.7754C514.027 51.6191 513.736 51.4414 513.494 51.2422C513.252 51.043 513.066 50.8145 512.938 50.5566C512.809 50.2988 512.744 50.0039 512.744 49.6719C512.744 49.3398 512.812 49.0332 512.949 48.752C513.086 48.4707 513.281 48.2266 513.535 48.0195C513.793 47.8086 514.1 47.6445 514.455 47.5273C514.811 47.4102 515.207 47.3516 515.645 47.3516C516.285 47.3516 516.828 47.4746 517.273 47.7207C517.723 47.9629 518.064 48.2812 518.299 48.6758C518.533 49.0664 518.65 49.4844 518.65 49.9297H517.525C517.525 49.6094 517.457 49.3262 517.32 49.0801C517.184 48.8301 516.977 48.6348 516.699 48.4941C516.422 48.3496 516.07 48.2773 515.645 48.2773C515.242 48.2773 514.91 48.3379 514.648 48.459C514.387 48.5801 514.191 48.7441 514.062 48.9512C513.938 49.1582 513.875 49.3945 513.875 49.6602C513.875 49.8398 513.912 50.0039 513.986 50.1523C514.064 50.2969 514.184 50.4316 514.344 50.5566C514.508 50.6816 514.715 50.7969 514.965 50.9023C515.219 51.0078 515.521 51.1094 515.873 51.207C516.357 51.3438 516.775 51.4961 517.127 51.6641C517.479 51.832 517.768 52.0215 517.994 52.2324C518.225 52.4395 518.395 52.6758 518.504 52.9414C518.617 53.2031 518.674 53.5 518.674 53.832C518.674 54.1797 518.604 54.4941 518.463 54.7754C518.322 55.0566 518.121 55.2969 517.859 55.4961C517.598 55.6953 517.283 55.8496 516.916 55.959C516.553 56.0645 516.146 56.1172 515.697 56.1172C515.303 56.1172 514.914 56.0625 514.531 55.9531C514.152 55.8438 513.807 55.6797 513.494 55.4609C513.186 55.2422 512.938 54.9727 512.75 54.6523C512.566 54.3281 512.475 53.9531 512.475 53.5273H513.6C513.6 53.8203 513.656 54.0723 513.77 54.2832C513.883 54.4902 514.037 54.6621 514.232 54.7988C514.432 54.9355 514.656 55.0371 514.906 55.1035C515.16 55.166 515.424 55.1973 515.697 55.1973C516.092 55.1973 516.426 55.1426 516.699 55.0332C516.973 54.9238 517.18 54.7676 517.32 54.5645C517.465 54.3613 517.537 54.1211 517.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.537 53.8438C541.537 53.6445 541.506 53.4688 541.443 53.3164C541.385 53.1602 541.279 53.0195 541.127 52.8945C540.979 52.7695 540.771 52.6504 540.506 52.5371C540.244 52.4238 539.912 52.3086 539.51 52.1914C539.088 52.0664 538.707 51.9277 538.367 51.7754C538.027 51.6191 537.736 51.4414 537.494 51.2422C537.252 51.043 537.066 50.8145 536.938 50.5566C536.809 50.2988 536.744 50.0039 536.744 49.6719C536.744 49.3398 536.812 49.0332 536.949 48.752C537.086 48.4707 537.281 48.2266 537.535 48.0195C537.793 47.8086 538.1 47.6445 538.455 47.5273C538.811 47.4102 539.207 47.3516 539.645 47.3516C540.285 47.3516 540.828 47.4746 541.273 47.7207C541.723 47.9629 542.064 48.2812 542.299 48.6758C542.533 49.0664 542.65 49.4844 542.65 49.9297H541.525C541.525 49.6094 541.457 49.3262 541.32 49.0801C541.184 48.8301 540.977 48.6348 540.699 48.4941C540.422 48.3496 540.07 48.2773 539.645 48.2773C539.242 48.2773 538.91 48.3379 538.648 48.459C538.387 48.5801 538.191 48.7441 538.062 48.9512C537.938 49.1582 537.875 49.3945 537.875 49.6602C537.875 49.8398 537.912 50.0039 537.986 50.1523C538.064 50.2969 538.184 50.4316 538.344 50.5566C538.508 50.6816 538.715 50.7969 538.965 50.9023C539.219 51.0078 539.521 51.1094 539.873 51.207C540.357 51.3438 540.775 51.4961 541.127 51.6641C541.479 51.832 541.768 52.0215 541.994 52.2324C542.225 52.4395 542.395 52.6758 542.504 52.9414C542.617 53.2031 542.674 53.5 542.674 53.832C542.674 54.1797 542.604 54.4941 542.463 54.7754C542.322 55.0566 542.121 55.2969 541.859 55.4961C541.598 55.6953 541.283 55.8496 540.916 55.959C540.553 56.0645 540.146 56.1172 539.697 56.1172C539.303 56.1172 538.914 56.0625 538.531 55.9531C538.152 55.8438 537.807 55.6797 537.494 55.4609C537.186 55.2422 536.938 54.9727 536.75 54.6523C536.566 54.3281 536.475 53.9531 536.475 53.5273H537.6C537.6 53.8203 537.656 54.0723 537.77 54.2832C537.883 54.4902 538.037 54.6621 538.232 54.7988C538.432 54.9355 538.656 55.0371 538.906 55.1035C539.16 55.166 539.424 55.1973 539.697 55.1973C540.092 55.1973 540.426 55.1426 540.699 55.0332C540.973 54.9238 541.18 54.7676 541.32 54.5645C541.465 54.3613 541.537 54.1211 541.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.728 23.0469V33H641.012V23.0469H642.728ZM646.788 27.4014V28.7617H642.29V27.4014H646.788ZM647.355 23.0469V24.4141H642.29V23.0469H647.355ZM651.839 33.1367C651.292 33.1367 650.798 33.0479 650.356 32.8701C649.918 32.6878 649.544 32.4349 649.234 32.1113C648.929 31.7878 648.694 31.4072 648.53 30.9697C648.366 30.5322 648.284 30.0605 648.284 29.5547V29.2812C648.284 28.7025 648.369 28.1784 648.537 27.709C648.706 27.2396 648.941 26.8385 649.241 26.5059C649.542 26.1686 649.898 25.9111 650.308 25.7334C650.718 25.5557 651.162 25.4668 651.641 25.4668C652.169 25.4668 652.632 25.5557 653.028 25.7334C653.425 25.9111 653.753 26.1618 654.013 26.4854C654.277 26.8044 654.473 27.1849 654.601 27.627C654.733 28.069 654.799 28.5566 654.799 29.0898V29.7939H649.084V28.6113H653.172V28.4814C653.163 28.1852 653.104 27.9072 652.994 27.6475C652.889 27.3877 652.728 27.1781 652.509 27.0186C652.29 26.859 651.998 26.7793 651.634 26.7793C651.36 26.7793 651.117 26.8385 650.902 26.957C650.693 27.071 650.517 27.2373 650.376 27.4561C650.235 27.6748 650.125 27.9391 650.048 28.249C649.975 28.5544 649.939 28.8984 649.939 29.2812V29.5547C649.939 29.8783 649.982 30.179 650.068 30.457C650.16 30.7305 650.292 30.9697 650.465 31.1748C650.638 31.3799 650.848 31.5417 651.094 31.6602C651.34 31.7741 651.62 31.8311 651.935 31.8311C652.331 31.8311 652.684 31.7513 652.994 31.5918C653.304 31.4323 653.573 31.2067 653.801 30.915L654.669 31.7559C654.51 31.9883 654.302 32.2116 654.047 32.4258C653.792 32.6354 653.48 32.8063 653.11 32.9385C652.746 33.0706 652.322 33.1367 651.839 33.1367ZM656.261 22.5H657.908V31.4209L657.751 33H656.261V22.5ZM662.735 29.2334V29.377C662.735 29.9238 662.673 30.4274 662.55 30.8877C662.431 31.3434 662.249 31.7399 662.003 32.0771C661.762 32.4144 661.461 32.6764 661.101 32.8633C660.745 33.0456 660.333 33.1367 659.863 33.1367C659.403 33.1367 659.002 33.0501 658.66 32.877C658.319 32.7038 658.031 32.4577 657.799 32.1387C657.571 31.8197 657.387 31.4391 657.245 30.9971C657.104 30.555 657.004 30.0674 656.944 29.5342V29.0762C657.004 28.5384 657.104 28.0508 657.245 27.6133C657.387 27.1712 657.571 26.7907 657.799 26.4717C658.031 26.1481 658.316 25.8997 658.653 25.7266C658.995 25.5534 659.394 25.4668 659.85 25.4668C660.324 25.4668 660.741 25.5579 661.101 25.7402C661.465 25.9225 661.768 26.1823 662.01 26.5195C662.251 26.8522 662.431 27.2487 662.55 27.709C662.673 28.1693 662.735 28.6774 662.735 29.2334ZM661.087 29.377V29.2334C661.087 28.9007 661.06 28.5885 661.005 28.2969C660.95 28.0007 660.859 27.7409 660.732 27.5176C660.609 27.2943 660.44 27.1188 660.226 26.9912C660.016 26.859 659.754 26.793 659.44 26.793C659.148 26.793 658.897 26.8431 658.688 26.9434C658.478 27.0436 658.303 27.1803 658.161 27.3535C658.02 27.5267 657.908 27.7272 657.826 27.9551C657.749 28.1829 657.696 28.429 657.669 28.6934V29.9307C657.71 30.2725 657.797 30.5869 657.929 30.874C658.066 31.1566 658.257 31.3844 658.503 31.5576C658.749 31.7262 659.066 31.8105 659.453 31.8105C659.759 31.8105 660.016 31.749 660.226 31.626C660.435 31.5029 660.602 31.332 660.725 31.1133C660.852 30.89 660.944 30.6302 660.998 30.334C661.057 30.0378 661.087 29.7188 661.087 29.377Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.848 47.4688H576.943L579.738 54.4238L582.527 47.4688H583.629L580.16 56H579.305L575.848 47.4688ZM575.49 47.4688H576.457L576.615 52.6719V56H575.49V47.4688ZM583.014 47.4688H583.98V56H582.855V52.6719L583.014 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.143 47.4688V56H603.029V47.4688H604.143ZM606.885 47.4688V48.3945H600.293V47.4688H606.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.734 53.4219L627.428 47.4688H628.248L627.773 49.7832L625.951 56H625.137L625.734 53.4219ZM623.982 47.4688L625.33 53.3047L625.734 56H624.926L622.857 47.4688H623.982ZM630.439 53.2988L631.758 47.4688H632.889L630.826 56H630.018L630.439 53.2988ZM628.371 47.4688L630.018 53.4219L630.615 56H629.801L628.043 49.7832L627.562 47.4688H628.371Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.143 47.4688V56H651.029V47.4688H652.143ZM654.885 47.4688V48.3945H648.293V47.4688H654.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.621 47.4688V56H673.49V47.4688H674.621ZM678.195 51.3066V52.2324H674.375V51.3066H678.195ZM678.775 47.4688V48.3945H674.375V47.4688H678.775Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.537 53.8438C701.537 53.6445 701.506 53.4688 701.443 53.3164C701.385 53.1602 701.279 53.0195 701.127 52.8945C700.979 52.7695 700.771 52.6504 700.506 52.5371C700.244 52.4238 699.912 52.3086 699.51 52.1914C699.088 52.0664 698.707 51.9277 698.367 51.7754C698.027 51.6191 697.736 51.4414 697.494 51.2422C697.252 51.043 697.066 50.8145 696.938 50.5566C696.809 50.2988 696.744 50.0039 696.744 49.6719C696.744 49.3398 696.812 49.0332 696.949 48.752C697.086 48.4707 697.281 48.2266 697.535 48.0195C697.793 47.8086 698.1 47.6445 698.455 47.5273C698.811 47.4102 699.207 47.3516 699.645 47.3516C700.285 47.3516 700.828 47.4746 701.273 47.7207C701.723 47.9629 702.064 48.2812 702.299 48.6758C702.533 49.0664 702.65 49.4844 702.65 49.9297H701.525C701.525 49.6094 701.457 49.3262 701.32 49.0801C701.184 48.8301 700.977 48.6348 700.699 48.4941C700.422 48.3496 700.07 48.2773 699.645 48.2773C699.242 48.2773 698.91 48.3379 698.648 48.459C698.387 48.5801 698.191 48.7441 698.062 48.9512C697.938 49.1582 697.875 49.3945 697.875 49.6602C697.875 49.8398 697.912 50.0039 697.986 50.1523C698.064 50.2969 698.184 50.4316 698.344 50.5566C698.508 50.6816 698.715 50.7969 698.965 50.9023C699.219 51.0078 699.521 51.1094 699.873 51.207C700.357 51.3438 700.775 51.4961 701.127 51.6641C701.479 51.832 701.768 52.0215 701.994 52.2324C702.225 52.4395 702.395 52.6758 702.504 52.9414C702.617 53.2031 702.674 53.5 702.674 53.832C702.674 54.1797 702.604 54.4941 702.463 54.7754C702.322 55.0566 702.121 55.2969 701.859 55.4961C701.598 55.6953 701.283 55.8496 700.916 55.959C700.553 56.0645 700.146 56.1172 699.697 56.1172C699.303 56.1172 698.914 56.0625 698.531 55.9531C698.152 55.8438 697.807 55.6797 697.494 55.4609C697.186 55.2422 696.938 54.9727 696.75 54.6523C696.566 54.3281 696.475 53.9531 696.475 53.5273H697.6C697.6 53.8203 697.656 54.0723 697.77 54.2832C697.883 54.4902 698.037 54.6621 698.232 54.7988C698.432 54.9355 698.656 55.0371 698.906 55.1035C699.16 55.166 699.424 55.1973 699.697 55.1973C700.092 55.1973 700.426 55.1426 700.699 55.0332C700.973 54.9238 701.18 54.7676 701.32 54.5645C701.465 54.3613 701.537 54.1211 701.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.537 53.8438C725.537 53.6445 725.506 53.4688 725.443 53.3164C725.385 53.1602 725.279 53.0195 725.127 52.8945C724.979 52.7695 724.771 52.6504 724.506 52.5371C724.244 52.4238 723.912 52.3086 723.51 52.1914C723.088 52.0664 722.707 51.9277 722.367 51.7754C722.027 51.6191 721.736 51.4414 721.494 51.2422C721.252 51.043 721.066 50.8145 720.938 50.5566C720.809 50.2988 720.744 50.0039 720.744 49.6719C720.744 49.3398 720.812 49.0332 720.949 48.752C721.086 48.4707 721.281 48.2266 721.535 48.0195C721.793 47.8086 722.1 47.6445 722.455 47.5273C722.811 47.4102 723.207 47.3516 723.645 47.3516C724.285 47.3516 724.828 47.4746 725.273 47.7207C725.723 47.9629 726.064 48.2812 726.299 48.6758C726.533 49.0664 726.65 49.4844 726.65 49.9297H725.525C725.525 49.6094 725.457 49.3262 725.32 49.0801C725.184 48.8301 724.977 48.6348 724.699 48.4941C724.422 48.3496 724.07 48.2773 723.645 48.2773C723.242 48.2773 722.91 48.3379 722.648 48.459C722.387 48.5801 722.191 48.7441 722.062 48.9512C721.938 49.1582 721.875 49.3945 721.875 49.6602C721.875 49.8398 721.912 50.0039 721.986 50.1523C722.064 50.2969 722.184 50.4316 722.344 50.5566C722.508 50.6816 722.715 50.7969 722.965 50.9023C723.219 51.0078 723.521 51.1094 723.873 51.207C724.357 51.3438 724.775 51.4961 725.127 51.6641C725.479 51.832 725.768 52.0215 725.994 52.2324C726.225 52.4395 726.395 52.6758 726.504 52.9414C726.617 53.2031 726.674 53.5 726.674 53.832C726.674 54.1797 726.604 54.4941 726.463 54.7754C726.322 55.0566 726.121 55.2969 725.859 55.4961C725.598 55.6953 725.283 55.8496 724.916 55.959C724.553 56.0645 724.146 56.1172 723.697 56.1172C723.303 56.1172 722.914 56.0625 722.531 55.9531C722.152 55.8438 721.807 55.6797 721.494 55.4609C721.186 55.2422 720.938 54.9727 720.75 54.6523C720.566 54.3281 720.475 53.9531 720.475 53.5273H721.6C721.6 53.8203 721.656 54.0723 721.77 54.2832C721.883 54.4902 722.037 54.6621 722.232 54.7988C722.432 54.9355 722.656 55.0371 722.906 55.1035C723.16 55.166 723.424 55.1973 723.697 55.1973C724.092 55.1973 724.426 55.1426 724.699 55.0332C724.973 54.9238 725.18 54.7676 725.32 54.5645C725.465 54.3613 725.537 54.1211 725.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.728 23.0469V33H825.012V23.0469H826.728ZM830.788 27.4014V28.7617H826.29V27.4014H830.788ZM831.355 23.0469V24.4141H826.29V23.0469H831.355ZM835.839 33.1367C835.292 33.1367 834.798 33.0479 834.356 32.8701C833.918 32.6878 833.544 32.4349 833.234 32.1113C832.929 31.7878 832.694 31.4072 832.53 30.9697C832.366 30.5322 832.284 30.0605 832.284 29.5547V29.2812C832.284 28.7025 832.369 28.1784 832.537 27.709C832.706 27.2396 832.941 26.8385 833.241 26.5059C833.542 26.1686 833.898 25.9111 834.308 25.7334C834.718 25.5557 835.162 25.4668 835.641 25.4668C836.169 25.4668 836.632 25.5557 837.028 25.7334C837.425 25.9111 837.753 26.1618 838.013 26.4854C838.277 26.8044 838.473 27.1849 838.601 27.627C838.733 28.069 838.799 28.5566 838.799 29.0898V29.7939H833.084V28.6113H837.172V28.4814C837.163 28.1852 837.104 27.9072 836.994 27.6475C836.889 27.3877 836.728 27.1781 836.509 27.0186C836.29 26.859 835.998 26.7793 835.634 26.7793C835.36 26.7793 835.117 26.8385 834.902 26.957C834.693 27.071 834.517 27.2373 834.376 27.4561C834.235 27.6748 834.125 27.9391 834.048 28.249C833.975 28.5544 833.939 28.8984 833.939 29.2812V29.5547C833.939 29.8783 833.982 30.179 834.068 30.457C834.16 30.7305 834.292 30.9697 834.465 31.1748C834.638 31.3799 834.848 31.5417 835.094 31.6602C835.34 31.7741 835.62 31.8311 835.935 31.8311C836.331 31.8311 836.684 31.7513 836.994 31.5918C837.304 31.4323 837.573 31.2067 837.801 30.915L838.669 31.7559C838.51 31.9883 838.302 32.2116 838.047 32.4258C837.792 32.6354 837.48 32.8063 837.11 32.9385C836.746 33.0706 836.322 33.1367 835.839 33.1367ZM840.261 22.5H841.908V31.4209L841.751 33H840.261V22.5ZM846.735 29.2334V29.377C846.735 29.9238 846.673 30.4274 846.55 30.8877C846.431 31.3434 846.249 31.7399 846.003 32.0771C845.762 32.4144 845.461 32.6764 845.101 32.8633C844.745 33.0456 844.333 33.1367 843.863 33.1367C843.403 33.1367 843.002 33.0501 842.66 32.877C842.319 32.7038 842.031 32.4577 841.799 32.1387C841.571 31.8197 841.387 31.4391 841.245 30.9971C841.104 30.555 841.004 30.0674 840.944 29.5342V29.0762C841.004 28.5384 841.104 28.0508 841.245 27.6133C841.387 27.1712 841.571 26.7907 841.799 26.4717C842.031 26.1481 842.316 25.8997 842.653 25.7266C842.995 25.5534 843.394 25.4668 843.85 25.4668C844.324 25.4668 844.741 25.5579 845.101 25.7402C845.465 25.9225 845.768 26.1823 846.01 26.5195C846.251 26.8522 846.431 27.2487 846.55 27.709C846.673 28.1693 846.735 28.6774 846.735 29.2334ZM845.087 29.377V29.2334C845.087 28.9007 845.06 28.5885 845.005 28.2969C844.95 28.0007 844.859 27.7409 844.732 27.5176C844.609 27.2943 844.44 27.1188 844.226 26.9912C844.016 26.859 843.754 26.793 843.44 26.793C843.148 26.793 842.897 26.8431 842.688 26.9434C842.478 27.0436 842.303 27.1803 842.161 27.3535C842.02 27.5267 841.908 27.7272 841.826 27.9551C841.749 28.1829 841.696 28.429 841.669 28.6934V29.9307C841.71 30.2725 841.797 30.5869 841.929 30.874C842.066 31.1566 842.257 31.3844 842.503 31.5576C842.749 31.7262 843.066 31.8105 843.453 31.8105C843.759 31.8105 844.016 31.749 844.226 31.626C844.435 31.5029 844.602 31.332 844.725 31.1133C844.852 30.89 844.944 30.6302 844.998 30.334C845.057 30.0378 845.087 29.7188 845.087 29.377Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.848 47.4688H760.943L763.738 54.4238L766.527 47.4688H767.629L764.16 56H763.305L759.848 47.4688ZM759.49 47.4688H760.457L760.615 52.6719V56H759.49V47.4688ZM767.014 47.4688H767.98V56H766.855V52.6719L767.014 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.143 47.4688V56H787.029V47.4688H788.143ZM790.885 47.4688V48.3945H784.293V47.4688H790.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.734 53.4219L811.428 47.4688H812.248L811.773 49.7832L809.951 56H809.137L809.734 53.4219ZM807.982 47.4688L809.33 53.3047L809.734 56H808.926L806.857 47.4688H807.982ZM814.439 53.2988L815.758 47.4688H816.889L814.826 56H814.018L814.439 53.2988ZM812.371 47.4688L814.018 53.4219L814.615 56H813.801L812.043 49.7832L811.562 47.4688H812.371Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.143 47.4688V56H835.029V47.4688H836.143ZM838.885 47.4688V48.3945H832.293V47.4688H838.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.621 47.4688V56H857.49V47.4688H858.621ZM862.195 51.3066V52.2324H858.375V51.3066H862.195ZM862.775 47.4688V48.3945H858.375V47.4688H862.775Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.537 53.8438C885.537 53.6445 885.506 53.4688 885.443 53.3164C885.385 53.1602 885.279 53.0195 885.127 52.8945C884.979 52.7695 884.771 52.6504 884.506 52.5371C884.244 52.4238 883.912 52.3086 883.51 52.1914C883.088 52.0664 882.707 51.9277 882.367 51.7754C882.027 51.6191 881.736 51.4414 881.494 51.2422C881.252 51.043 881.066 50.8145 880.938 50.5566C880.809 50.2988 880.744 50.0039 880.744 49.6719C880.744 49.3398 880.812 49.0332 880.949 48.752C881.086 48.4707 881.281 48.2266 881.535 48.0195C881.793 47.8086 882.1 47.6445 882.455 47.5273C882.811 47.4102 883.207 47.3516 883.645 47.3516C884.285 47.3516 884.828 47.4746 885.273 47.7207C885.723 47.9629 886.064 48.2812 886.299 48.6758C886.533 49.0664 886.65 49.4844 886.65 49.9297H885.525C885.525 49.6094 885.457 49.3262 885.32 49.0801C885.184 48.8301 884.977 48.6348 884.699 48.4941C884.422 48.3496 884.07 48.2773 883.645 48.2773C883.242 48.2773 882.91 48.3379 882.648 48.459C882.387 48.5801 882.191 48.7441 882.062 48.9512C881.938 49.1582 881.875 49.3945 881.875 49.6602C881.875 49.8398 881.912 50.0039 881.986 50.1523C882.064 50.2969 882.184 50.4316 882.344 50.5566C882.508 50.6816 882.715 50.7969 882.965 50.9023C883.219 51.0078 883.521 51.1094 883.873 51.207C884.357 51.3438 884.775 51.4961 885.127 51.6641C885.479 51.832 885.768 52.0215 885.994 52.2324C886.225 52.4395 886.395 52.6758 886.504 52.9414C886.617 53.2031 886.674 53.5 886.674 53.832C886.674 54.1797 886.604 54.4941 886.463 54.7754C886.322 55.0566 886.121 55.2969 885.859 55.4961C885.598 55.6953 885.283 55.8496 884.916 55.959C884.553 56.0645 884.146 56.1172 883.697 56.1172C883.303 56.1172 882.914 56.0625 882.531 55.9531C882.152 55.8438 881.807 55.6797 881.494 55.4609C881.186 55.2422 880.938 54.9727 880.75 54.6523C880.566 54.3281 880.475 53.9531 880.475 53.5273H881.6C881.6 53.8203 881.656 54.0723 881.77 54.2832C881.883 54.4902 882.037 54.6621 882.232 54.7988C882.432 54.9355 882.656 55.0371 882.906 55.1035C883.16 55.166 883.424 55.1973 883.697 55.1973C884.092 55.1973 884.426 55.1426 884.699 55.0332C884.973 54.9238 885.18 54.7676 885.32 54.5645C885.465 54.3613 885.537 54.1211 885.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.537 53.8438C909.537 53.6445 909.506 53.4688 909.443 53.3164C909.385 53.1602 909.279 53.0195 909.127 52.8945C908.979 52.7695 908.771 52.6504 908.506 52.5371C908.244 52.4238 907.912 52.3086 907.51 52.1914C907.088 52.0664 906.707 51.9277 906.367 51.7754C906.027 51.6191 905.736 51.4414 905.494 51.2422C905.252 51.043 905.066 50.8145 904.938 50.5566C904.809 50.2988 904.744 50.0039 904.744 49.6719C904.744 49.3398 904.812 49.0332 904.949 48.752C905.086 48.4707 905.281 48.2266 905.535 48.0195C905.793 47.8086 906.1 47.6445 906.455 47.5273C906.811 47.4102 907.207 47.3516 907.645 47.3516C908.285 47.3516 908.828 47.4746 909.273 47.7207C909.723 47.9629 910.064 48.2812 910.299 48.6758C910.533 49.0664 910.65 49.4844 910.65 49.9297H909.525C909.525 49.6094 909.457 49.3262 909.32 49.0801C909.184 48.8301 908.977 48.6348 908.699 48.4941C908.422 48.3496 908.07 48.2773 907.645 48.2773C907.242 48.2773 906.91 48.3379 906.648 48.459C906.387 48.5801 906.191 48.7441 906.062 48.9512C905.938 49.1582 905.875 49.3945 905.875 49.6602C905.875 49.8398 905.912 50.0039 905.986 50.1523C906.064 50.2969 906.184 50.4316 906.344 50.5566C906.508 50.6816 906.715 50.7969 906.965 50.9023C907.219 51.0078 907.521 51.1094 907.873 51.207C908.357 51.3438 908.775 51.4961 909.127 51.6641C909.479 51.832 909.768 52.0215 909.994 52.2324C910.225 52.4395 910.395 52.6758 910.504 52.9414C910.617 53.2031 910.674 53.5 910.674 53.832C910.674 54.1797 910.604 54.4941 910.463 54.7754C910.322 55.0566 910.121 55.2969 909.859 55.4961C909.598 55.6953 909.283 55.8496 908.916 55.959C908.553 56.0645 908.146 56.1172 907.697 56.1172C907.303 56.1172 906.914 56.0625 906.531 55.9531C906.152 55.8438 905.807 55.6797 905.494 55.4609C905.186 55.2422 904.938 54.9727 904.75 54.6523C904.566 54.3281 904.475 53.9531 904.475 53.5273H905.6C905.6 53.8203 905.656 54.0723 905.77 54.2832C905.883 54.4902 906.037 54.6621 906.232 54.7988C906.432 54.9355 906.656 55.0371 906.906 55.1035C907.16 55.166 907.424 55.1973 907.697 55.1973C908.092 55.1973 908.426 55.1426 908.699 55.0332C908.973 54.9238 909.18 54.7676 909.32 54.5645C909.465 54.3613 909.537 54.1211 909.537 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.73 23.0469V33H1009.01V23.0469H1010.73ZM1014.79 27.4014V28.7617H1010.29V27.4014H1014.79ZM1015.36 23.0469V24.4141H1010.29V23.0469H1015.36ZM1019.84 33.1367C1019.29 33.1367 1018.8 33.0479 1018.36 32.8701C1017.92 32.6878 1017.54 32.4349 1017.23 32.1113C1016.93 31.7878 1016.69 31.4072 1016.53 30.9697C1016.37 30.5322 1016.28 30.0605 1016.28 29.5547V29.2812C1016.28 28.7025 1016.37 28.1784 1016.54 27.709C1016.71 27.2396 1016.94 26.8385 1017.24 26.5059C1017.54 26.1686 1017.9 25.9111 1018.31 25.7334C1018.72 25.5557 1019.16 25.4668 1019.64 25.4668C1020.17 25.4668 1020.63 25.5557 1021.03 25.7334C1021.42 25.9111 1021.75 26.1618 1022.01 26.4854C1022.28 26.8044 1022.47 27.1849 1022.6 27.627C1022.73 28.069 1022.8 28.5566 1022.8 29.0898V29.7939H1017.08V28.6113H1021.17V28.4814C1021.16 28.1852 1021.1 27.9072 1020.99 27.6475C1020.89 27.3877 1020.73 27.1781 1020.51 27.0186C1020.29 26.859 1020 26.7793 1019.63 26.7793C1019.36 26.7793 1019.12 26.8385 1018.9 26.957C1018.69 27.071 1018.52 27.2373 1018.38 27.4561C1018.23 27.6748 1018.13 27.9391 1018.05 28.249C1017.98 28.5544 1017.94 28.8984 1017.94 29.2812V29.5547C1017.94 29.8783 1017.98 30.179 1018.07 30.457C1018.16 30.7305 1018.29 30.9697 1018.46 31.1748C1018.64 31.3799 1018.85 31.5417 1019.09 31.6602C1019.34 31.7741 1019.62 31.8311 1019.93 31.8311C1020.33 31.8311 1020.68 31.7513 1020.99 31.5918C1021.3 31.4323 1021.57 31.2067 1021.8 30.915L1022.67 31.7559C1022.51 31.9883 1022.3 32.2116 1022.05 32.4258C1021.79 32.6354 1021.48 32.8063 1021.11 32.9385C1020.75 33.0706 1020.32 33.1367 1019.84 33.1367ZM1024.26 22.5H1025.91V31.4209L1025.75 33H1024.26V22.5ZM1030.73 29.2334V29.377C1030.73 29.9238 1030.67 30.4274 1030.55 30.8877C1030.43 31.3434 1030.25 31.7399 1030 32.0771C1029.76 32.4144 1029.46 32.6764 1029.1 32.8633C1028.75 33.0456 1028.33 33.1367 1027.86 33.1367C1027.4 33.1367 1027 33.0501 1026.66 32.877C1026.32 32.7038 1026.03 32.4577 1025.8 32.1387C1025.57 31.8197 1025.39 31.4391 1025.25 30.9971C1025.1 30.555 1025 30.0674 1024.94 29.5342V29.0762C1025 28.5384 1025.1 28.0508 1025.25 27.6133C1025.39 27.1712 1025.57 26.7907 1025.8 26.4717C1026.03 26.1481 1026.32 25.8997 1026.65 25.7266C1027 25.5534 1027.39 25.4668 1027.85 25.4668C1028.32 25.4668 1028.74 25.5579 1029.1 25.7402C1029.47 25.9225 1029.77 26.1823 1030.01 26.5195C1030.25 26.8522 1030.43 27.2487 1030.55 27.709C1030.67 28.1693 1030.73 28.6774 1030.73 29.2334ZM1029.09 29.377V29.2334C1029.09 28.9007 1029.06 28.5885 1029.01 28.2969C1028.95 28.0007 1028.86 27.7409 1028.73 27.5176C1028.61 27.2943 1028.44 27.1188 1028.23 26.9912C1028.02 26.859 1027.75 26.793 1027.44 26.793C1027.15 26.793 1026.9 26.8431 1026.69 26.9434C1026.48 27.0436 1026.3 27.1803 1026.16 27.3535C1026.02 27.5267 1025.91 27.7272 1025.83 27.9551C1025.75 28.1829 1025.7 28.429 1025.67 28.6934V29.9307C1025.71 30.2725 1025.8 30.5869 1025.93 30.874C1026.07 31.1566 1026.26 31.3844 1026.5 31.5576C1026.75 31.7262 1027.07 31.8105 1027.45 31.8105C1027.76 31.8105 1028.02 31.749 1028.23 31.626C1028.44 31.5029 1028.6 31.332 1028.72 31.1133C1028.85 30.89 1028.94 30.6302 1029 30.334C1029.06 30.0378 1029.09 29.7188 1029.09 29.377Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.848 47.4688H944.943L947.738 54.4238L950.527 47.4688H951.629L948.16 56H947.305L943.848 47.4688ZM943.49 47.4688H944.457L944.615 52.6719V56H943.49V47.4688ZM951.014 47.4688H951.98V56H950.855V52.6719L951.014 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.143 47.4688V56H971.029V47.4688H972.143ZM974.885 47.4688V48.3945H968.293V47.4688H974.885Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.734 53.4219L995.428 47.4688H996.248L995.773 49.7832L993.951 56H993.137L993.734 53.4219ZM991.982 47.4688L993.33 53.3047L993.734 56H992.926L990.857 47.4688H991.982ZM998.439 53.2988L999.758 47.4688H1000.89L998.826 56H998.018L998.439 53.2988ZM996.371 47.4688L998.018 53.4219L998.615 56H997.801L996.043 49.7832L995.562 47.4688H996.371Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.14 47.4688V56H1019.03V47.4688H1020.14ZM1022.88 47.4688V48.3945H1016.29V47.4688H1022.88Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.62 47.4688V56H1041.49V47.4688H1042.62ZM1046.2 51.3066V52.2324H1042.38V51.3066H1046.2ZM1046.78 47.4688V48.3945H1042.38V47.4688H1046.78Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.54 53.8438C1069.54 53.6445 1069.51 53.4688 1069.44 53.3164C1069.38 53.1602 1069.28 53.0195 1069.13 52.8945C1068.98 52.7695 1068.77 52.6504 1068.51 52.5371C1068.24 52.4238 1067.91 52.3086 1067.51 52.1914C1067.09 52.0664 1066.71 51.9277 1066.37 51.7754C1066.03 51.6191 1065.74 51.4414 1065.49 51.2422C1065.25 51.043 1065.07 50.8145 1064.94 50.5566C1064.81 50.2988 1064.74 50.0039 1064.74 49.6719C1064.74 49.3398 1064.81 49.0332 1064.95 48.752C1065.09 48.4707 1065.28 48.2266 1065.54 48.0195C1065.79 47.8086 1066.1 47.6445 1066.46 47.5273C1066.81 47.4102 1067.21 47.3516 1067.64 47.3516C1068.29 47.3516 1068.83 47.4746 1069.27 47.7207C1069.72 47.9629 1070.06 48.2812 1070.3 48.6758C1070.53 49.0664 1070.65 49.4844 1070.65 49.9297H1069.53C1069.53 49.6094 1069.46 49.3262 1069.32 49.0801C1069.18 48.8301 1068.98 48.6348 1068.7 48.4941C1068.42 48.3496 1068.07 48.2773 1067.64 48.2773C1067.24 48.2773 1066.91 48.3379 1066.65 48.459C1066.39 48.5801 1066.19 48.7441 1066.06 48.9512C1065.94 49.1582 1065.88 49.3945 1065.88 49.6602C1065.88 49.8398 1065.91 50.0039 1065.99 50.1523C1066.06 50.2969 1066.18 50.4316 1066.34 50.5566C1066.51 50.6816 1066.71 50.7969 1066.96 50.9023C1067.22 51.0078 1067.52 51.1094 1067.87 51.207C1068.36 51.3438 1068.78 51.4961 1069.13 51.6641C1069.48 51.832 1069.77 52.0215 1069.99 52.2324C1070.22 52.4395 1070.39 52.6758 1070.5 52.9414C1070.62 53.2031 1070.67 53.5 1070.67 53.832C1070.67 54.1797 1070.6 54.4941 1070.46 54.7754C1070.32 55.0566 1070.12 55.2969 1069.86 55.4961C1069.6 55.6953 1069.28 55.8496 1068.92 55.959C1068.55 56.0645 1068.15 56.1172 1067.7 56.1172C1067.3 56.1172 1066.91 56.0625 1066.53 55.9531C1066.15 55.8438 1065.81 55.6797 1065.49 55.4609C1065.19 55.2422 1064.94 54.9727 1064.75 54.6523C1064.57 54.3281 1064.47 53.9531 1064.47 53.5273H1065.6C1065.6 53.8203 1065.66 54.0723 1065.77 54.2832C1065.88 54.4902 1066.04 54.6621 1066.23 54.7988C1066.43 54.9355 1066.66 55.0371 1066.91 55.1035C1067.16 55.166 1067.42 55.1973 1067.7 55.1973C1068.09 55.1973 1068.43 55.1426 1068.7 55.0332C1068.97 54.9238 1069.18 54.7676 1069.32 54.5645C1069.46 54.3613 1069.54 54.1211 1069.54 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.54 53.8438C1093.54 53.6445 1093.51 53.4688 1093.44 53.3164C1093.38 53.1602 1093.28 53.0195 1093.13 52.8945C1092.98 52.7695 1092.77 52.6504 1092.51 52.5371C1092.24 52.4238 1091.91 52.3086 1091.51 52.1914C1091.09 52.0664 1090.71 51.9277 1090.37 51.7754C1090.03 51.6191 1089.74 51.4414 1089.49 51.2422C1089.25 51.043 1089.07 50.8145 1088.94 50.5566C1088.81 50.2988 1088.74 50.0039 1088.74 49.6719C1088.74 49.3398 1088.81 49.0332 1088.95 48.752C1089.09 48.4707 1089.28 48.2266 1089.54 48.0195C1089.79 47.8086 1090.1 47.6445 1090.46 47.5273C1090.81 47.4102 1091.21 47.3516 1091.64 47.3516C1092.29 47.3516 1092.83 47.4746 1093.27 47.7207C1093.72 47.9629 1094.06 48.2812 1094.3 48.6758C1094.53 49.0664 1094.65 49.4844 1094.65 49.9297H1093.53C1093.53 49.6094 1093.46 49.3262 1093.32 49.0801C1093.18 48.8301 1092.98 48.6348 1092.7 48.4941C1092.42 48.3496 1092.07 48.2773 1091.64 48.2773C1091.24 48.2773 1090.91 48.3379 1090.65 48.459C1090.39 48.5801 1090.19 48.7441 1090.06 48.9512C1089.94 49.1582 1089.88 49.3945 1089.88 49.6602C1089.88 49.8398 1089.91 50.0039 1089.99 50.1523C1090.06 50.2969 1090.18 50.4316 1090.34 50.5566C1090.51 50.6816 1090.71 50.7969 1090.96 50.9023C1091.22 51.0078 1091.52 51.1094 1091.87 51.207C1092.36 51.3438 1092.78 51.4961 1093.13 51.6641C1093.48 51.832 1093.77 52.0215 1093.99 52.2324C1094.22 52.4395 1094.39 52.6758 1094.5 52.9414C1094.62 53.2031 1094.67 53.5 1094.67 53.832C1094.67 54.1797 1094.6 54.4941 1094.46 54.7754C1094.32 55.0566 1094.12 55.2969 1093.86 55.4961C1093.6 55.6953 1093.28 55.8496 1092.92 55.959C1092.55 56.0645 1092.15 56.1172 1091.7 56.1172C1091.3 56.1172 1090.91 56.0625 1090.53 55.9531C1090.15 55.8438 1089.81 55.6797 1089.49 55.4609C1089.19 55.2422 1088.94 54.9727 1088.75 54.6523C1088.57 54.3281 1088.47 53.9531 1088.47 53.5273H1089.6C1089.6 53.8203 1089.66 54.0723 1089.77 54.2832C1089.88 54.4902 1090.04 54.6621 1090.23 54.7988C1090.43 54.9355 1090.66 55.0371 1090.91 55.1035C1091.16 55.166 1091.42 55.1973 1091.7 55.1973C1092.09 55.1973 1092.43 55.1426 1092.7 55.0332C1092.97 54.9238 1093.18 54.7676 1093.32 54.5645C1093.46 54.3613 1093.54 54.1211 1093.54 53.8438Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1086,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 942,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.11 30.0127V23.0469H1198.82V30.0127C1198.82 30.6735 1198.67 31.2363 1198.39 31.7012C1198.11 32.166 1197.72 32.5215 1197.24 32.7676C1196.75 33.0137 1196.19 33.1367 1195.58 33.1367C1194.94 33.1367 1194.38 33.0296 1193.89 32.8154C1193.4 32.6012 1193.02 32.2731 1192.74 31.8311C1192.46 31.389 1192.32 30.8285 1192.32 30.1494H1194.04C1194.04 30.5413 1194.11 30.8581 1194.23 31.0996C1194.36 31.3366 1194.53 31.5098 1194.76 31.6191C1194.99 31.724 1195.27 31.7764 1195.58 31.7764C1195.87 31.7764 1196.13 31.7103 1196.36 31.5781C1196.59 31.4414 1196.78 31.2432 1196.91 30.9834C1197.04 30.7191 1197.11 30.3955 1197.11 30.0127ZM1204.97 31.5166V27.9893C1204.97 27.7249 1204.92 27.4971 1204.82 27.3057C1204.73 27.1143 1204.58 26.9661 1204.39 26.8613C1204.19 26.7565 1203.95 26.7041 1203.66 26.7041C1203.39 26.7041 1203.16 26.7497 1202.96 26.8408C1202.77 26.932 1202.62 27.055 1202.51 27.21C1202.4 27.3649 1202.34 27.5404 1202.34 27.7363H1200.7C1200.7 27.4447 1200.77 27.1621 1200.91 26.8887C1201.05 26.6152 1201.26 26.3714 1201.53 26.1572C1201.8 25.943 1202.12 25.7744 1202.49 25.6514C1202.87 25.5283 1203.29 25.4668 1203.75 25.4668C1204.31 25.4668 1204.8 25.5602 1205.23 25.7471C1205.66 25.9339 1206 26.2165 1206.25 26.5947C1206.5 26.9684 1206.62 27.4378 1206.62 28.0029V31.291C1206.62 31.6283 1206.64 31.9313 1206.69 32.2002C1206.74 32.4645 1206.81 32.6947 1206.9 32.8906V33H1205.21C1205.14 32.8223 1205.07 32.5967 1205.03 32.3232C1204.99 32.0452 1204.97 31.7764 1204.97 31.5166ZM1205.21 28.502L1205.22 29.5205H1204.04C1203.73 29.5205 1203.46 29.5501 1203.23 29.6094C1203 29.6641 1202.8 29.7461 1202.65 29.8555C1202.49 29.9648 1202.38 30.097 1202.3 30.252C1202.22 30.4069 1202.18 30.5824 1202.18 30.7783C1202.18 30.9743 1202.23 31.1543 1202.32 31.3184C1202.41 31.4779 1202.54 31.6032 1202.72 31.6943C1202.9 31.7855 1203.11 31.8311 1203.36 31.8311C1203.7 31.8311 1203.99 31.7627 1204.24 31.626C1204.5 31.4847 1204.7 31.3138 1204.84 31.1133C1204.99 30.9082 1205.07 30.7145 1205.08 30.5322L1205.61 31.2637C1205.55 31.4505 1205.46 31.651 1205.33 31.8652C1205.2 32.0794 1205.02 32.2845 1204.81 32.4805C1204.6 32.6719 1204.35 32.8291 1204.05 32.9521C1203.76 33.0752 1203.42 33.1367 1203.04 33.1367C1202.56 33.1367 1202.13 33.041 1201.75 32.8496C1201.37 32.6536 1201.07 32.3916 1200.86 32.0635C1200.64 31.7308 1200.54 31.3548 1200.54 30.9355C1200.54 30.5436 1200.61 30.1973 1200.76 29.8965C1200.91 29.5911 1201.13 29.3359 1201.41 29.1309C1201.7 28.9258 1202.06 28.7708 1202.48 28.666C1202.9 28.5566 1203.38 28.502 1203.91 28.502H1205.21ZM1210.15 27.1826V33H1208.5V25.6035H1210.05L1210.15 27.1826ZM1209.85 29.0283L1209.32 29.0215C1209.33 28.4974 1209.4 28.0166 1209.54 27.5791C1209.69 27.1416 1209.89 26.7656 1210.14 26.4512C1210.4 26.1367 1210.71 25.8952 1211.07 25.7266C1211.43 25.5534 1211.83 25.4668 1212.27 25.4668C1212.63 25.4668 1212.95 25.5169 1213.24 25.6172C1213.53 25.7129 1213.78 25.8701 1213.98 26.0889C1214.19 26.3076 1214.35 26.5924 1214.46 26.9434C1214.57 27.2897 1214.63 27.7158 1214.63 28.2217V33H1212.97V28.2148C1212.97 27.8594 1212.92 27.5791 1212.81 27.374C1212.71 27.1644 1212.57 27.0163 1212.37 26.9297C1212.18 26.8385 1211.94 26.793 1211.65 26.793C1211.37 26.793 1211.12 26.8522 1210.89 26.9707C1210.67 27.0892 1210.48 27.251 1210.33 27.4561C1210.17 27.6611 1210.06 27.8981 1209.98 28.167C1209.89 28.4359 1209.85 28.723 1209.85 29.0283Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.85 47.4688H1128.94L1131.74 54.4238L1134.53 47.4688H1135.63L1132.16 56H1131.3L1127.85 47.4688ZM1127.49 47.4688H1128.46L1128.62 52.6719V56H1127.49V47.4688ZM1135.01 47.4688H1135.98V56H1134.86V52.6719L1135.01 47.4688Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.14 47.4688V56H1155.03V47.4688H1156.14ZM1158.88 47.4688V48.3945H1152.29V47.4688H1158.88Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 53.4219L1179.43 47.4688H1180.25L1179.77 49.7832L1177.95 56H1177.14L1177.73 53.4219ZM1175.98 47.4688L1177.33 53.3047L1177.73 56H1176.93L1174.86 47.4688H1175.98ZM1182.44 53.2988L1183.76 47.4688H1184.89L1182.83 56H1182.02L1182.44 53.2988ZM1180.37 47.4688L1182.02 53.4219L1182.62 56H1181.8L1180.04 49.7832L1179.56 47.4688H1180.37Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.14 47.4688V56H1203.03V47.4688H1204.14ZM1206.88 47.4688V48.3945H1200.29V47.4688H1206.88Z",
    fill: "black",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198,
    y: 94,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198,
    y: 118,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198,
    y: 142,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1150,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174,
    y: 166,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1D617A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_99362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1384,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_654_99362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2192,
    height: 168,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImg);
export default __webpack_public_path__ + "static/media/SVG_IMG.9c35d6fc13e067bc8e62980e667a9176.svg";
export { ForwardRef as ReactComponent };